import dayjs from 'dayjs';

import { CostReportChartDataPoint } from 'features/cost-report/types/charts';
import { TimeSeries } from 'types/metrics';

export const getFutureDatapointIndex = (
  data: TimeSeries<CostReportChartDataPoint>
): number | undefined => {
  const estimatedStartIndex = data.findIndex(
    ({ forecast, isForecast }) => forecast || isForecast
  );
  return estimatedStartIndex >= 0 ? estimatedStartIndex : undefined;
};

const secondsBetween = (a: string, b: string): number =>
  dayjs(b).diff(dayjs(a), 'second');

/** Drop sub-step points so Recharts time-axis bars keep a usable band width. */
export const collapseCloseTimePoints = <T extends object>(
  data: TimeSeries<T>
): TimeSeries<T> => {
  if (data.length < 3) return data;

  const gaps = data
    .slice(1)
    .map((point, i) => secondsBetween(data[i].timestamp, point.timestamp));
  const medianGap = [...gaps].sort((a, b) => a - b)[
    Math.floor(gaps.length / 2)
  ];
  if (!medianGap) return data;

  const minGap = medianGap / 2;
  const [first, ...rest] = data;

  return rest.reduce<TimeSeries<T>>(
    (acc, point) => {
      const prev = acc.at(-1)!;
      if (secondsBetween(prev.timestamp, point.timestamp) < minGap) {
        acc[acc.length - 1] = point;
      } else {
        acc.push(point);
      }
      return acc;
    },
    [first]
  );
};
